<div class="modal-header" id="confirmation-summary-modal-title">
    <h3 class="modal-title" id="modal-title" translate="CONFIRMATION_SUMMARY_TITLE"></h3>
    <span class="close" (click)="!isLoading && modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <fieldset [formGroup]="confirmationSummaryForm" [disabled]="isLoading">
        <div class="row mb-3">
            <div class="col-12 col-lg-6" *ngIf="!model.confirmationModel.timeRecording.isNotificationRemoteWork">
                <div class="row" *ngIf="model.timeRecordingTravelToFirstEntry">
                    <label
                        class="col-12 col-lg-3 col-form-label text-start text-lg-end"
                        for="summaryTripToWithStandby"
                        translate="CONFIRMATION_SUMMARY_TRIP_TO_LABEL"
                    ></label>
                    <div class="col-12 col-lg-auto" id="summaryTripToWithStandby">
                        <span class="form-control-plaintext px-0">
                            {{
                                formatEntry(model.timeRecordingTravelToFirstEntry, model.timeRecordingTravelToLastEntry)
                            }}
                            | {{ formatDuration(model.timeRecordingTravelToDuration) }}
                        </span>
                    </div>
                </div>
                <div class="row" *ngIf="model.timeRecordingTravelToEntry && displayTravelTo">
                    <label
                        class="col-12 col-lg-3 col-form-label text-start text-lg-end"
                        for="summaryTripTo"
                        translate="CONFIRMATION_SUMMARY_TRIP_TO_LABEL"
                    ></label>
                    <div class="col-12 col-lg-auto" id="summaryTripTo">
                        <span class="form-control-plaintext px-0">
                            {{ formatEntry(model.timeRecordingTravelToEntry) }} |
                            {{ formatDuration(model.timeRecordingTravelToDuration) }}
                        </span>
                    </div>
                </div>
                <div class="row" *ngIf="model.timeRecordingPhoneFixEntry">
                    <label class="col-12 col-lg-3 col-form-label text-start text-lg-end" for="summaryPhoneFix">
                        {{ model.timeRecordingPhoneFixEntry.typeOfWorkModel.selectedEntry.displayName }}</label
                    >
                    <div class="col-12 col-lg-auto" id="summaryPhoneFix">
                        <span class="form-control-plaintext px-0">
                            {{ formatEntry(model.timeRecordingPhoneFixEntry) }} |
                            {{ formatDuration(model.timeRecordingPhoneFixDuration) }}
                        </span>
                    </div>
                </div>
                <!--Aggregated Work entry display for NGMP58-->
                <div class="row" *ngIf="model.timeRecordingOnsiteFirstEntry">
                    <label
                        class="col-12 col-lg-3 col-form-label text-start text-lg-end"
                        for="summaryWork"
                        translate="CONFIRMATION_SUMMARY_WORK_LABEL"
                    ></label>
                    <div class="col-12 col-lg-auto" id="summaryWork">
                        <span class="form-control-plaintext px-0">
                            {{ formatEntry(model.timeRecordingOnsiteFirstEntry, model.timeRecordingOnsiteLastEntry) }} |
                            {{ formatDuration(model.timeRecordingOnsiteDuration) }}
                        </span>
                    </div>
                </div>
                <!--Individual Work entries display for NGMAA-->
                <div
                    *ngFor="let entry of model.timeRecordingOnsiteEntriesList; index as i; trackBy: trackById"
                    class="row"
                >
                    <label
                        class="col-12 col-lg-3 col-form-label text-start text-lg-end"
                        for="summaryWork_{{ i }}"
                        translate="CONFIRMATION_SUMMARY_WORK_LABEL"
                    ></label>
                    <div class="col-12 col-lg-auto" id="summaryWork_{{ i }}">
                        <span class="form-control-plaintext px-0">
                            {{ formatEntry(entry, entry) }} |
                            {{ formatDuration(model.calculateTotalDuration([entry])) }}
                        </span>
                    </div>
                </div>
                <div class="row" *ngIf="model.timeRecordingBreakDuration">
                    <label
                        class="col-12 col-lg-3 col-form-label text-start text-lg-end"
                        for="summaryBreak"
                        translate="CONFIRMATION_SUMMARY_BREAK_LABEL"
                    ></label>
                    <div class="col-12 col-lg-auto" id="summaryBreak">
                        <span class="form-control-plaintext px-0">
                            {{ formatDuration(model.timeRecordingBreakDuration) }}
                        </span>
                    </div>
                </div>
                <div class="row" *ngIf="model.timeRecordingWaitDuration">
                    <label
                        class="col-12 col-lg-3 col-form-label text-start text-lg-end"
                        for="summaryWait"
                        translate="CONFIRMATION_SUMMARY_WAIT_LABEL"
                    ></label>
                    <div class="col-12 col-lg-auto" id="summaryWait">
                        <span class="form-control-plaintext px-0">
                            {{ formatDuration(model.timeRecordingWaitDuration) }}
                        </span>
                    </div>
                </div>
                <div class="row" *ngIf="model.timeRecordingTravelBackEntry && displayTravelBackSummary">
                    <label
                        class="col-12 col-lg-3 col-form-label text-start text-lg-end"
                        for="summaryTripBack"
                        translate="CONFIRMATION_SUMMARY_TRIP_BACK_LABEL"
                    ></label>
                    <div class="col-12 col-lg-auto" id="summaryTripBack">
                        <span class="form-control-plaintext px-0">
                            {{ formatEntry(model.timeRecordingTravelBackEntry) }} |
                            {{ formatDuration(model.timeRecordingTravelBackDuration) }}
                        </span>
                    </div>
                </div>
                <div class="row" *ngIf="selfAssignedTaskOriginalPlannedDate">
                    <label
                        class="col-12 col-lg-3 col-form-label text-start text-lg-end"
                        for="originalPlannedDate"
                        translate="CONFIRMATION_SUMMARY_ORIGINALLY_PLANNED_DATE_LABEL"
                    ></label>
                    <div class="col-12 col-lg-auto" id="originalPlannedDate">
                        <span class="form-control-plaintext px-0">{{
                            formatDateTime(selfAssignedTaskOriginalPlannedDate)
                        }}</span>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-8" *ngIf="model.confirmationModel.timeRecording.isNotificationRemoteWork">
                <div class="row" *ngIf="model.timeRecordingRemoteWorkFirstEntry">
                    <label class="col-12 col-lg-3 col-form-label text-start text-lg-end" for="summaryRemoteWork">{{
                        remoteWorkLabel
                    }}</label>
                    <div class="col-12 col-lg-9" id="summaryRemoteWork">
                        <span class="form-control-plaintext px-0">
                            {{
                                formatEntry(
                                    model.timeRecordingRemoteWorkFirstEntry,
                                    model.timeRecordingRemoteWorkLastEntry
                                )
                            }}
                            | {{ formatDuration(model.timeRecordingRemoteWorkDuration) }}
                        </span>
                    </div>
                </div>
                <div class="row" *ngIf="model.timeRecordingBreakDuration">
                    <label
                        class="col-12 col-lg-3 col-form-label text-start text-lg-end"
                        for="summaryRemoteBreak"
                        translate="CONFIRMATION_SUMMARY_BREAK_LABEL"
                    ></label>
                    <div class="col-12 col-lg-9" id="summaryRemoteBreak">
                        <span class="form-control-plaintext px-0">
                            {{ formatDuration(model.timeRecordingBreakDuration) }}
                        </span>
                    </div>
                </div>
                <div class="row" *ngIf="model.timeRecordingWaitDuration">
                    <label
                        class="col-12 col-lg-3 col-form-label text-start text-lg-end"
                        for="summaryRemoteWait"
                        translate="CONFIRMATION_SUMMARY_WAIT_LABEL"
                    ></label>
                    <div class="col-12 col-lg-9" id="summaryRemoteWait">
                        <span class="form-control-plaintext px-0">
                            {{ formatDuration(model.timeRecordingWaitDuration) }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-4">
                <div class="row" *ngIf="displaySystemRecovery">
                    <label
                        class="col-12 col-lg-6 col-form-label text-start text-lg-end"
                        for="summaryRecovery"
                        translate="CONFIRMATION_SUMMARY_SYSTEM_RECOVERY_LABEL"
                    ></label>
                    <div class="col-12 col-lg-auto" id="summaryRecovery">
                        <span class="form-control-plaintext px-0"> {{ formatDateTime(model.recoveryDateTime) }} </span>
                    </div>
                </div>
                <div class="row" *ngIf="displayDistance">
                    <label
                        class="col-12 col-lg-6 col-form-label text-start text-lg-end"
                        for="summaryDistance"
                        translate="CONFIRMATION_SUMMARY_DISTANCE_LABEL"
                    ></label>
                    <div class="col-12 col-lg-auto" id="summaryDistance">
                        <span class="form-control-plaintext px-0">
                            {{ confirmationModel.expenses.distance.value }}
                            <span translate="CONFIRMATION_EXPENSES_KM_LABEL"></span>
                        </span>
                    </div>
                </div>
                <div class="row" *ngIf="displayFollowUp">
                    <label
                        class="col-12 col-lg-6 col-form-label text-start text-lg-end"
                        for="summaryFollowUp"
                        translate="CONFIRMATION_SUMMARY_FOLLOWUP_LABEL"
                    ></label>
                    <div class="col-12 col-lg-auto" id="summaryFollowUp">
                        <span class="form-control-plaintext px-0"> {{ followUpSelectedEntry }} </span>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="row mb-3"
            *ngIf="
                confirmationModel.followup?.showLegalCheckHandover &&
                confirmationModel.followup?.followupOptions.selectedEntry.value === optionValueNo
            "
        >
            <div class="col-12 offset-lg-6 col-lg-6">
                <div class="row">
                    <label
                        class="col-12 col-lg-8 col-form-label text-start text-lg-end"
                        for="summaryHandoverSafetyInfo"
                        >{{ confirmationModel.followup.legalCheckHandoverSafetyInformationText }}</label
                    >
                    <div class="col-12 col-lg-4" id="summaryHandoverSafetyInfo">
                        <span class="form-control-plaintext px-0">
                            {{
                                confirmationModel.followup.legalCheckHandoverSafetyInformation.selectedEntry.displayName
                            }}
                        </span>
                    </div>
                </div>
                <div class="row">
                    <label class="col-12 col-lg-8 col-form-label text-start text-lg-end" for="summaryHandoverUserDoc">{{
                        confirmationModel.followup.legalCheckHandoverUserDocumentationText
                    }}</label>
                    <div class="col-12 col-lg-4" id="summaryHandoverUserDoc">
                        <span class="form-control-plaintext px-0">
                            {{
                                confirmationModel.followup.legalCheckHandoverUserDocumentation.selectedEntry.displayName
                            }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <!-- row -->
        <ng-container *ngIf="confirmationModel.measurementTool?.showLegalCheckVerification">
            <div class="row mb-3">
                <ng-container
                    *ngIf="
                        confirmationModel.measurementTool.legalCheckVerifiedSecurityDevice.selectedEntry.value ===
                        optionValueYes
                    "
                >
                    <label class="col-12 col-lg-10 col-form-label text-start text-lg-end">
                        {{ confirmationModel.measurementTool.legalCheckVerifiedSecurityDeviceText }}
                    </label>
                    <div class="col-12 col-lg-2">
                        <span class="form-control-plaintext px-0">
                            {{
                                confirmationModel.measurementTool.legalCheckVerifiedSecurityDevice.selectedEntry
                                    .displayName
                            }}
                        </span>
                    </div>
                </ng-container>
                <ng-container
                    *ngIf="
                        confirmationModel.measurementTool.legalCheckResumptionAfterUserValidation.selectedEntry
                            .value === optionValueYes
                    "
                >
                    <label class="col-12 col-lg-10 col-form-label text-start text-lg-end">
                        {{ confirmationModel.measurementTool.legalCheckResumptionAfterUserValidationText }}
                    </label>
                    <div class="col-12 col-lg-2">
                        <span class="form-control-plaintext px-0">
                            {{
                                confirmationModel.measurementTool.legalCheckResumptionAfterUserValidation.selectedEntry
                                    .displayName
                            }}
                        </span>
                    </div>
                </ng-container>
            </div>
        </ng-container>
        <!-- row -->
        <ng-container *ngIf="affectedEquipment">
            <hr />
            <div class="row mb-3">
                <label
                    class="col-12 col-lg-2 col-form-label text-start text-lg-end"
                    for="affectedEquipment"
                    translate="CONFIRMATION_SUMMARY_AFFECTED_EQUIPMENT_LABEL"
                ></label>
                <div class="col-12 col-lg-8" id="affectedEquipment">
                    <span class="form-control-plaintext px-0">{{ affectedEquipment }}</span>
                </div>
            </div>
        </ng-container>
        <!-- row -->
        <ng-container *ngIf="displayTroubleText">
            <hr />
            <div class="row mb-3">
                <label
                    class="col-12 col-lg-2 col-form-label text-start text-lg-end"
                    translate="CONFIRMATION_SUMMARY_TROUBLE_TEXT_LABEL"
                ></label>
                <div class="col-12 col-lg-8">
                    <pace-core-text-input
                        [(model)]="model.troubleText"
                        [parentForm]="confirmationSummaryFormChildren"
                    ></pace-core-text-input>
                </div>
            </div>
        </ng-container>
        <!-- row -->
        <ng-container *ngIf="displayReportCodes">
            <hr />
            <div class="row mb-3">
                <label
                    class="col-12 col-lg-2 col-form-label text-start text-lg-end"
                    translate="CONFIRMATION_SUMMARY_REPORT_CODE_LABEL"
                ></label>
                <div class="col-12 col-lg-8">
                    <span class="form-control-plaintext px-0">{{ model.reportCodes }}</span>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="displayReportText">
            <hr />
            <div class="row mb-3">
                <label
                    class="col-12 col-lg-2 col-form-label text-start text-lg-end"
                    translate="CONFIRMATION_SUMMARY_REPORT_TEXT_LABEL"
                ></label>
                <div class="col-12 col-lg-8">
                    <div class="form-control-plaintext px-0 new-line-wrapper">{{ model.reportText?.value }}</div>
                </div>
            </div>
        </ng-container>
        <!-- row -->
        <ng-container
            *ngIf="confirmationModel.equipment?.phiDataCode && confirmationModel.equipment?.phiDataCode.selectedEntry"
        >
            <hr />
            <div class="row mb-3">
                <label
                    class="col-12 col-lg-2 col-form-label text-start text-lg-end"
                    translate="CONFIRMATION_SUMMARY_PHI_DATA_CODE_LABEL"
                ></label>
                <div class="col-12 col-lg-8">
                    <span class="form-control-plaintext px-0">
                        {{ confirmationModel.equipment.equipmentNr.value }} -
                        {{ confirmationModel.equipment.equipments.selectedEntry.displayName }} -
                        {{ confirmationModel.equipment.phiDataCode.selectedEntry.displayName }}
                    </span>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="model.additionalExpensesText">
            <hr />
            <div class="row mb-3">
                <label
                    class="col-12 col-lg-2 col-form-label text-start text-lg-end"
                    translate="CONFIRMATION_EXPENSES_LABEL"
                ></label>
                <div class="col-12 col-lg-10" id="additionalExpenses">
                    <span class="form-control-plaintext px-0"> {{ model.additionalExpensesText }} </span>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="model.isMaterialTaxiBillable()">
            <div class="row mb-3">
                <label
                    class="col-12 col-lg-2 col-form-label text-start text-lg-end"
                    translate="CONFIRMATION_SUMMARY_MATERIAL_LABEL"
                ></label>
                <div class="col-12 col-lg-10" id="additionalTaxiCost">
                    <span
                        class="form-control-plaintext px-0"
                        translate="CONFIRMATION_MATERIAL_TAXI_ADDITIONAL_COST"
                    ></span>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="isShortConfirmation && displayMaterial">
            <pace-confirmation-summary-material
                [materials]="model.summaryMaterial"
            ></pace-confirmation-summary-material>
        </ng-container>
        <!-- For short confirmation, contact person and signature is not required.-->
        <ng-container *ngIf="!isShortConfirmation">
            <hr />
            <div class="row">
                <div class="col-12">
                    <div class="row" *ngIf="model.confirmationModel.uploadToDocBox?.documentTitle.length > 0">
                        <label
                            class="col-12 col-lg-2 col-form-label text-start text-lg-end"
                            for="uploadedToDocBox"
                            translate="CONFIRMATION_UPLOADED_TO_DOCBOX_LABEL"
                        ></label>
                        <div class="col-12 col-lg-8" id="uploadedToDocBox">
                            <div *ngFor="let docTitle of model.confirmationModel.uploadToDocBox.documentTitle">
                                <span class="form-control-plaintext px-0"> {{ docTitle }} </span>
                            </div>
                        </div>
                    </div>
                    <pace-confirmation-summary-material
                        *ngIf="displayMaterial"
                        [materials]="model.summaryMaterial"
                    ></pace-confirmation-summary-material>
                    <pace-confirmation-summary-participants
                        *ngIf="displayParticipants"
                        [participants]="model.summaryParticipants"
                        [displayMobileNumber]="displayMobileNumber"
                    ></pace-confirmation-summary-participants>
                    <pace-confirmation-summary-measurement-tools
                        [displayMeasurementTool]="displayMeasurementTool"
                        [measurementTools]="model.measurementTools"
                        [displayMeasurementToolDetails]="displayMeasurementToolDetails"
                        [measurementToolsDetailsList]="model.measurementToolsDetailsList"
                        [measurementToolsEmptyMessage]="measurementToolsEmptyMessage"
                        [isRadioActiveToolsUsed]="isRadioActiveToolsUsed"
                    ></pace-confirmation-summary-measurement-tools>
                </div>
            </div>

            <hr />

            <div *ngIf="displayCustomerInformation">
                <div class="row">
                    <div class="col-12">
                        <h4 translate="CONFIRMATION_SUMMARY_CUSTOMER_INFORMATION_TITLE"></h4>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-12 col-lg-6">
                        <div class="row">
                            <label
                                class="col-12 col-lg-4 col-form-label text-start text-lg-end"
                                for="functional-location"
                                translate="CONFIRMATION_SUMMARY_FUNCTIONAL_LOCATION_LABEL"
                            ></label>
                            <div class="col-12 col-lg-8" id="functional-location">
                                <span class="form-control-plaintext px-0"> {{ notification.functionalLoc }} </span>
                            </div>
                        </div>
                        <div class="row">
                            <label
                                class="col-12 col-lg-4 col-form-label text-start text-lg-end"
                                for="customer-name"
                                translate="CONFIRMATION_SUMMARY_CUSTOMER_NAME_LABEL"
                            ></label>
                            <div class="col-12 col-lg-8" id="customer-name">
                                <span class="form-control-plaintext px-0">
                                    {{ notification.address.completeName }}
                                </span>
                            </div>
                        </div>
                        <div class="row">
                            <label
                                class="col-12 col-lg-4 col-form-label text-start text-lg-end"
                                for="notification-number"
                                translate="CONFIRMATION_SUMMARY_NOTIFICATION_NUMBER_LABEL"
                            ></label>
                            <div class="col-12 col-lg-8" id="notification-number">
                                <span class="form-control-plaintext px-0">
                                    {{ notification.identifier.qmNum }} ({{ notification.identifier.maNum }})
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div class="row">
                            <label
                                class="col-12 col-lg-4 col-form-label text-start text-lg-end"
                                for="main-equipment-name"
                                translate="CONFIRMATION_SUMMARY_MAIN_EQUIPMENT_NAME_LABEL"
                            ></label>
                            <div class="col-12 col-lg-8" id="main-equipment-name">
                                <span class="form-control-plaintext px-0">
                                    {{ notification.getMainEquipment().equiShortDesc.value }}
                                </span>
                            </div>
                        </div>
                        <div class="row">
                            <label
                                class="col-12 col-lg-4 col-form-label text-start text-lg-end"
                                for="main-equipment-number"
                                translate="CONFIRMATION_SUMMARY_MAIN_EQUIPMENT_NUMBER_LABEL"
                            ></label>
                            <div class="col-12 col-lg-8" id="main-equipment-number">
                                <span class="form-control-plaintext px-0">
                                    {{ notification.getMainEquipment().equnr.value }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mb-3 mt-lg-5">
                <label
                    class="col-12 col-lg-2 col-form-label text-start text-lg-end"
                    for="customerName"
                    translate="CONFIRMATION_SUMMARY_CUSTOMER_NAME_LABEL"
                ></label>
                <div class="col-12 col-lg-4">
                    <pace-core-text-input
                        id="customerName"
                        [(model)]="model.customerName"
                        [parentForm]="confirmationSummaryFormChildren"
                        [ariaLabel]="'CONFIRMATION_SUMMARY_CUSTOMER_NAME_LABEL' | translate"
                    >
                    </pace-core-text-input>
                </div>
            </div>
            <ng-container *ngIf="displayCustomerContact">
                <div class="row mb-3 mt-lg-5">
                    <label
                        class="col-12 col-lg-2 col-form-label text-start text-lg-end"
                        for="customerContact"
                        translate="CONFIRMATION_SUMMARY_CUSTOMER_CONTACT_LABEL"
                    ></label>
                    <div class="col-12 col-lg-4">
                        <pace-core-text-input
                            [(model)]="model.customerContact"
                            [ariaLabel]="'CONFIRMATION_SUMMARY_CUSTOMER_CONTACT_LABEL' | translate"
                            [parentForm]="confirmationSummaryFormChildren"
                            id="customerContact"
                        >
                        </pace-core-text-input>
                    </div>
                </div>
            </ng-container>
            <div class="row mb-3" *ngIf="!!model.customerAgreementTextClause">
                <div class="col-12 offset-lg-2 col-lg-8">
                    <span class="form-control-plaintext px-0 new-line-wrapper">{{
                        model.customerAgreementTextClause
                    }}</span>
                </div>
            </div>

            <div class="mb-3">
                <div class="row mb-3 mt-lg-5">
                    <ng-container *ngIf="displayCustomerSignature">
                        <label
                            class="col-12 col-lg-2 col-form-label text-start text-lg-end"
                            for="customerSignature"
                            translate="CONFIRMATION_SUMMARY_SIGNATURE_LABEL"
                        ></label>
                        <div class="col-12 col-lg-4" [ngClass]="{ 'no-pointer-events': isLoading }">
                            <canvas
                                #customerSignatureCanvasElement
                                class="signature-canvas w-100"
                                [ngClass]="{
                                    'ng-dimmed': model.customerNotAvail.value,
                                    'ng-invalid':
                                        customerSignaturePad &&
                                        customerSignaturePad.isEmpty &&
                                        !model.customerNotAvail.value,
                                }"
                                id="customerSignature"
                            ></canvas>
                        </div>
                        <div class="col-lg-6 d-flex justify-content-start align-items-center d-lg-none">
                            <pace-core-checkbox-input
                                (valueChange)="customerNotAvailChanged()"
                                [(model)]="model.customerNotAvail"
                                [parentForm]="confirmationSummaryFormChildren"
                                class="me-3"
                            >
                            </pace-core-checkbox-input>
                            <button
                                type="button"
                                class="btn btn-secondary"
                                (click)="clearCustomerSignature()"
                                translate="CONFIRMATION_SUMMARY_CLEAR_LABEL"
                            ></button>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="displayCseSignature">
                        <label
                            class="col-12 col-lg-2 col-form-label text-start text-lg-end"
                            for="cseSignature"
                            translate="CONFIRMATION_SUMMARY_CSE_SIGNATURE_LABEL"
                        ></label>
                        <div class="col-12 col-lg-4" [ngClass]="{ 'no-pointer-events': isLoading }">
                            <canvas
                                #cseSignatureCanvasElement
                                class="signature-canvas w-100"
                                [ngClass]="{ 'ng-invalid': cseSignaturePad && cseSignaturePad.isEmpty }"
                                id="cseSignature"
                            ></canvas>
                        </div>
                    </ng-container>
                </div>
            </div>

            <div class="row mt-2">
                <div
                    *ngIf="displayCustomerSignature"
                    class="col-lg-6 d-flex justify-content-end align-items-lg-start d-none d-lg-flex"
                >
                    <pace-core-checkbox-input
                        [(model)]="model.customerNotAvail"
                        [parentForm]="confirmationSummaryFormChildren"
                        (valueChange)="customerNotAvailChanged()"
                        class="me-4"
                    >
                    </pace-core-checkbox-input>
                    <button
                        type="button"
                        class="btn btn-secondary"
                        (click)="clearCustomerSignature()"
                        translate="CONFIRMATION_SUMMARY_CLEAR_LABEL"
                    ></button>
                </div>
                <div
                    *ngIf="displayCseSignature"
                    class="col-lg-6 d-flex justify-content-md-start justify-content-lg-end align-items-center"
                >
                    <button
                        type="button"
                        class="btn btn-secondary float-end"
                        (click)="clearCseSignature()"
                        translate="CONFIRMATION_SUMMARY_CLEAR_LABEL"
                    ></button>
                </div>
            </div>
        </ng-container>
    </fieldset>
</div>
<div class="modal-footer">
    <button
        class="btn btn-primary"
        *ngIf="!isShortConfirmation && !isLoading"
        type="button"
        [disabled]="confirmationSummaryForm.invalid"
        (click)="confirmSignatures()"
        translate="CONFIRMATION_SUMMARY_SUBMIT_CONFIRMATION_REPORT_LABEL"
    ></button>
    <button
        class="btn btn-primary"
        *ngIf="isShortConfirmation && !isLoading"
        type="button"
        (click)="submit()"
        translate="CONFIRMATION_SUMMARY_SUBMIT_SHORT_CONFIRMATION_LABEL"
    ></button>
    <progressbar type="default" [value]="100" *ngIf="isLoading">
        {{ 'CONFIRMATION_SUMMARY_PROGRESSBAR_LABEL' | translate }}
    </progressbar>
</div>
